import React from 'react';
import { useTranslation } from 'react-i18next';

import { OmaLummeApp } from '../../omaLummeContext';

import ContactForm from './ContactForm';
import ContactLiftups from './ContactLiftups';
import Infobox from './Infobox';
import Box from '../Common/Box';
import Button from '../Common/Button';
import SubMenu from '../Common/SubMenu';

// Utils.
import { gaPageviewIfAllowed } from '../../utils/googleAnalytics';
import Loading from '../Common/Loading';

const ContactPage: React.FunctionComponent = () => {
  const { users } = OmaLummeApp.useState();
  const { endpoint } = users.activeUser;
  const { t } = useTranslation();
  const [pageview, setPageview] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!pageview) {
      gaPageviewIfAllowed('/contactPage');
      setPageview(true);
    }
  }, [pageview]);

  const usersLoading = users.activeUser.userId === 0 && users.activeUser.userName === '';

  const contact = (
    <div className="contact-us">
      <Infobox endpoint={endpoint} />
      <div className="image"></div>
      <div className="white-circle"></div>
    </div>
  );

  const buttons = (
    <div className="contact-buttons">
      <Button onClick={(): void => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}>
        {t('customerService:contactUs.messageButton')}
      </Button>
    </div>
  );

  const liftups = <ContactLiftups />;

  return (
    <>
      <Box>
        {usersLoading && <Loading />}
        {!usersLoading && (
          <>
            {endpoint !== 'anon' && <SubMenu />}
            {contact}
            {buttons}
            {liftups}
          </>
        )}
      </Box>
      {!usersLoading && (
        <Box color="lavender">
          <ContactForm />
        </Box>
      )}
    </>
  );
};

export default ContactPage;
